module.exports = __webpack_public_path__ + "img/your-donation.db266921.jpg";